import { Button, IconButton, Modal, Typography } from "@mui/material";
import { CrossIcon } from "../Plans/icons/GPTIcons/CrossIcon";
import LoadingButton from "./LoadingButton";
import { ReactNode } from "react";

type DeleteModalProps = {
  open: boolean;
  handleDelete: () => void;
  handleCloseWarning: () => void;
  mainText: string;
  subText?: string;
  isDeleting?: boolean;
  widthClassName?: string;
  additionalContent?: ReactNode;
  confirmText?: string;
  // Non-destructive confirms (e.g. billing-period switch) pass "" to fall
  // back to LoadingButton's brand-contained styling instead of the red.
  confirmColorClass?: string;
};
const DeleteModal = ({ open, handleDelete, handleCloseWarning, mainText, subText, isDeleting = false, widthClassName, additionalContent, confirmText = "Confirm deletion", confirmColorClass = "!bg-error-main hover:!bg-error-main" }: DeleteModalProps) => {
  const defaultWidthClasses = "w-modal-mobile sm:w-modal-md md:w-modal-lg";
  const widthClasses = widthClassName || defaultWidthClasses;

  return (
    <Modal open={open}>
      <div className={`absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 shadow ${widthClasses} rounded-lg p-6 bg-white text-mui-black-87 dark:bg-background/paper-elevation-16 dark:text-white`}>
        <div className="flex flex-col gap-y-6">
          <div className="flex justify-between items-center">
            <Typography variant="h6/medium-500" className="text-mui-black-87 dark:text-white">
              {mainText}
            </Typography>
            <IconButton
              size="small"
              onClick={handleCloseWarning}
              className="cross-icon"
            >
              <CrossIcon className="fill-current" />
            </IconButton>
          </div>

          <>
            <div className="text-sm">
              {subText}
            </div>
            {additionalContent && (
              <div>
                {additionalContent}
              </div>
            )}
            <div className="flex flex-col gap-y-4 md:flex-row gap-x-6 justify-center">

              <Button
                variant="outlined"
                size="large"
                fullWidth
                className="button-outlined"
                onClick={handleCloseWarning}
              >
                Cancel
              </Button>
              <LoadingButton
                variant="contained"
                size="large"
                fullWidth
                colorClass={confirmColorClass}
                onClick={handleDelete}
                isLoading={isDeleting}
              >
                {confirmText}
                {" "}
              </LoadingButton>
            </div>
          </>
        </div>
      </div>
    </Modal>
  );
};

export default DeleteModal;
